// import { useState, useRef, useEffect } from "react";
import { useRef } from "react";
import classes from "../styles/Spinner.module.css";
import Spinner from "./Spinner";
// import { useAppSelector, useAnimations } from "../hooks";
import { useAppSelector } from "../hooks";
import { getClasses } from "../utils";

const SpinnerOverlay: React.FC<{}> = () => {
  // const [hidden, setHidden] = useState(true);
  const { visible, style, size, stroke } = useAppSelector(
    (state) => state.spinnerOverlay
  );

  // const animations = {
  //   show: {
  //     duration: 1,
  //     opacity: 1,
  //     main: classes["overlay-show-start"],
  //     // NOTE: it is called "atStart/atEnd" in order to be different than the gsap "onStart/onEnd"
  //     atStart: () => setHidden(false),
  //   },
  //   hide: {
  //     duration: 0.6,
  //     opacity: 0,
  //     atEnd: () => setHidden(true),
  //   },
  // };

  const container = useRef(null);
  // const [animationClass, setAnimation] = useAnimations(
  //   animations,
  //   "spinner-overlay",
  //   container
  // );
  // useEffect(() => {
  //   setAnimation(visible ? "show" : "hide");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [visible]);

  if (!visible) return null;

  return (
    <div
      ref={container}
      className={getClasses(classes, "spinner-overlay")}
      style={style}
    >
      <Spinner visible={true} size={size} stroke={stroke} />
    </div>
  );
};

export default SpinnerOverlay;
